// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-switch-checkbox {
    height: 0;
    width: 0;
    position: absolute;
    visibility: hidden;
  }
  
  .react-switch {
    cursor: pointer;
    width: 50%;
    height: 3vh;
    background: #fff;
    position: relative;
    border-radius: 5px;

    transition: background-color 0.2s;
  }
  
  .react-switch .react-switch-button {
    position: absolute;
    z-index: 1;
    top: 0.5px;
    left: 0.5px;
    width: 20px;
    border-radius: 5px;
    height: 22px;
     transition: 0.2s;
    background: #5599FF;    ;
    box-shadow: 0 0 2px 0 rgba(255, 255, 255, 0.29);
    margin-top: auto;
    margin-bottom: auto;
  }
  
  .react-switch-checkbox:checked + .react-switch-button {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
  
  .react-switch-checkbox:active + .react-switch-button {
    width: 30px;
  }
  
  .react-switch-labels {
    display: relative;
    z-index: 0;
    height: 100%;

    font: 8pt "Segoe UI", Verdana, sans-serif;
  }
  
  .react-switch-labels span {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    width: 50%;
    height: 100%;
  }
  .react-switch-labels span:first-child {
    left: 0;
  }
  .react-switch-labels span:last-child {
    right: 0;
  }
  `, "",{"version":3,"sources":["webpack://./src/Pages/schedulerModule/components/TimeSlot/switch.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;;IAElB,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;KACX,gBAAgB;IACjB,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,YAAY;;IAEZ,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,YAAY;EACd;EACA;IACE,OAAO;EACT;EACA;IACE,QAAQ;EACV","sourcesContent":[".react-switch-checkbox {\n    height: 0;\n    width: 0;\n    position: absolute;\n    visibility: hidden;\n  }\n  \n  .react-switch {\n    cursor: pointer;\n    width: 50%;\n    height: 3vh;\n    background: #fff;\n    position: relative;\n    border-radius: 5px;\n\n    transition: background-color 0.2s;\n  }\n  \n  .react-switch .react-switch-button {\n    position: absolute;\n    z-index: 1;\n    top: 0.5px;\n    left: 0.5px;\n    width: 20px;\n    border-radius: 5px;\n    height: 22px;\n     transition: 0.2s;\n    background: #5599FF;    ;\n    box-shadow: 0 0 2px 0 rgba(255, 255, 255, 0.29);\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n  \n  .react-switch-checkbox:checked + .react-switch-button {\n    left: calc(100% - 2px);\n    transform: translateX(-100%);\n  }\n  \n  .react-switch-checkbox:active + .react-switch-button {\n    width: 30px;\n  }\n  \n  .react-switch-labels {\n    display: relative;\n    z-index: 0;\n    height: 100%;\n\n    font: 8pt \"Segoe UI\", Verdana, sans-serif;\n  }\n  \n  .react-switch-labels span {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #000;\n    width: 50%;\n    height: 100%;\n  }\n  .react-switch-labels span:first-child {\n    left: 0;\n  }\n  .react-switch-labels span:last-child {\n    right: 0;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
